module.exports = __webpack_public_path__ + "static/brinco-52e793c732de2799de723cd8abeb27a6.svg";